import { AppIcons } from "../../../data/appIcons";
import { GridColumnType } from "../../../data/gridColumnType";

export const ViewChangeKeyPositionCertificateCoOrdinatorConfig = {
  columns: [
    {
      name: "Request  Date",
      fieldName: "registrationDate",
      allowShort: false,
      colType: GridColumnType.DATE,
      colSettings: {
        format: 'DD MMM YYYY',
      },
    },
    // {
    //   name: "Email Address",
    //   fieldName: "email",
    //   allowShort: false,
    //   colType: GridColumnType.Text,
    // },
    {
      name: "Company Name",
      fieldName: "companyName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Company UEN",
      fieldName: "companyUEN",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Membership Type",
      fieldName: "membershipTypeName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Type of Request",
      fieldName: "requestTypeName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Role Changed",
      fieldName: "corporateRole",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Status",
      fieldName: "keyChangeStatusId",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Action",
      fieldName: "action",
      allowShort: false,
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false,
      },
      customAction: [
        {
          name: "VIEW",
          // iconName: AppIcons.copyIcon,
          iconName: AppIcons.editIconNew,
          onViewAction: (data) => {
            alert("called permissions");
          },
        },
      ],
    },
  ],
};
